// src/pages/SignupPage.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { supabase } from "../lib/supabase";
import "./Auth.css";

function SignupPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    department: "",
    duty: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMsg("");
    setLoading(true);

    if (!supabase) {
      setError("Supabase가 설정되지 않았습니다. 환경 변수를 확인해주세요.");
      setLoading(false);
      return;
    }

    try {
      const { data, error: signUpError } = await supabase.auth.signUp({
        email: form.email,
        password: form.password,
        options: {
          data: {
            name: form.name,
            full_name: form.name,
            department: form.department || null,
            duty: form.duty || null,
            role: 'user', // 기본값은 일반 사용자
          },
        },
      });

      if (signUpError) {
        throw signUpError;
      }

      if (data?.user) {
        setSuccessMsg("회원가입이 완료되었습니다. 로그인해주세요.");
        setTimeout(() => {
          navigate("/login");
        }, 1200);
      }
    } catch (err) {
      console.error("Register error:", err);
      setError(err.message || "회원가입에 실패했습니다.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        {/* 왼쪽: 포털 소개 영역 (로그인 페이지와 톤 맞추기) */}
        <div className="auth-left">
          <h1 className="portal-title">HR Analytics Portal</h1>
          <p className="portal-desc">
            인재경영 데이터를 한 곳에서 관리하고,
            조직의 HR 인사이트를 한눈에 확인하세요.
          </p>

          <ul className="portal-benefits">
            <li>인재경영·HR 관련 업무시간 입력 및 분석</li>
            <li>조직/부서별 인재경영 투입 현황 모니터링</li>
            <li>데이터 기반 HR 의사결정 지원</li>
          </ul>
        </div>

        {/* 오른쪽: 회원가입 폼 */}
        <div className="auth-right">
          <h2 className="auth-section-title">회원가입</h2>
          <p className="auth-section-desc">
            새로운 계정을 생성하고 HR Analytics 기능을 이용해 보세요.
          </p>

          <form onSubmit={handleSubmit} className="auth-form">
            <label className="auth-label">
              이름
              <input
                name="name"
                type="text"
                value={form.name}
                onChange={handleChange}
                className="auth-input"
                required
              />
            </label>

            <label className="auth-label">
              이메일
              <input
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                className="auth-input"
                required
              />
            </label>

            <label className="auth-label">
              비밀번호
              <input
                name="password"
                type="password"
                value={form.password}
                onChange={handleChange}
                className="auth-input"
                required
              />
            </label>

            <label className="auth-label">
              소속
              <input
                name="department"
                type="text"
                placeholder="예: 인사팀 / 개발팀 / 영업본부"
                value={form.department}
                onChange={handleChange}
                className="auth-input"
              />
            </label>

            <label className="auth-label">
              담당업무
              <input
                name="duty"
                type="text"
                placeholder="예: 채용 담당 / 백엔드 개발 / 데이터 분석"
                value={form.duty}
                onChange={handleChange}
                className="auth-input"
              />
            </label>

            {error && <div className="auth-error">{error}</div>}
            {successMsg && <div className="auth-success">{successMsg}</div>}

            <button
              className="auth-submit-btn"
              type="submit"
              disabled={loading}
            >
              {loading ? "가입 중..." : "회원가입"}
            </button>
          </form>

          <div className="auth-footer">
            이미 계정이 있으신가요?{" "}
            <Link to="/login" className="auth-link">
              로그인 하러 가기
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignupPage;